import { render, staticRenderFns } from "./QAlert.vue?vue&type=template&id=b85b50cc"
import script from "./QAlert.vue?vue&type=script&lang=ts"
export * from "./QAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports